import {
  ChangeDetectionStrategy,
  Component,
  AfterViewInit,
  OnDestroy,
  signal,
} from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SidebarComponent } from "../sidebar/sidebar.component";
import { AlertComponent } from "../alert/alert.component";
import { FooterComponent } from "../footer/footer.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-authenticated",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    SidebarComponent,
    AlertComponent,
    FooterComponent,
  ],
  templateUrl: "./authenticated.component.html",
  styleUrl: "./authenticated.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticatedComponent implements AfterViewInit, OnDestroy {
  sidebarWidth = signal<number>(0);
  private resizeObserver!: ResizeObserver;

  ngAfterViewInit() {
    const sidebarEl = document.getElementById("web-sidebar");

    if (!sidebarEl) {
      return;
    }

    this.sidebarWidth.set(sidebarEl.getBoundingClientRect().width);

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        this.sidebarWidth.set(entry.contentRect.width);
      }
    });

    this.resizeObserver.observe(sidebarEl);
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  get contentMaxWidth(): string {
    return `calc(100vw - ${this.sidebarWidth()}px)`;
  }
}
